import Vue from 'vue';
import defaultStateGlobal from './../../default.state.global';

export default {
  clear (state) {
    state = Object.assign(state, defaultStateGlobal);
  },
  setWaitingInquiries (state, newValue) {
    state.waitingInquiries = newValue.slice();
  },
  setWaitingInquiryStatus (state, payload) {
    let foundedInquiry = state.waitingInquiries.filter(inquiry => inquiry.id === payload.inquiryID);

    if (foundedInquiry[0]) {
      foundedInquiry[0].status = payload.status;
    }
  },
  setBookeroNews (state, newValue) {
    state.bookeroNews = newValue.slice();
  },
  markBookeroNewsAsReaded (state, payload) {
    Vue.set(state, 'bookeroNews', state.bookeroNews.map(news => {
      if (payload.indexOf(news.id) > -1) {
        news.readed = 1;
      }

      return news;
    }));
  },
  setNotifications (state, newValue) {
    state.notifications = newValue.slice();
  },
  removeInquiry (state, id) {
    state.waitingInquiries = state.waitingInquiries.filter(inquiry => inquiry.id !== id);
  },
  removeInquiriesCart (state, cartID) {
    state.waitingInquiries = state.waitingInquiries.filter(inquiry => inquiry.cart_id !== cartID);
  },
  markAsReadNotification (state, id) {
    Vue.set(state, 'notifications', state.notifications.map(notification => {
      if (notification.id === id) {
        notification.readed_at = 1;
      }

      return notification;
    }));
  },
  markAsReadAllNotifications (state) {
    Vue.set(state, 'notifications', state.notifications.map(notification => {
      notification.readed_at = 1;
      return notification;
    }));
  },
  setIncreasedPopupZindex (state, popupID) {
    state.popupZindex += 1;
    Vue.set(state.popupsZindexes, popupID, state.popupZindex);
  },
  removePopupZindex (state, popupID) {
    Vue.delete(state.popupsZindexes, popupID);
  }
}



// WEBPACK FOOTER //
// ./src/store/helpers/global/mutations.js